import * as React from "react";
const SvgIcChevronUp = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M16 14L12 10L8 14", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgIcChevronUp;
